export default "__VITE_ASSET__fUdCCAZC__"